import SectionBubbles from "./SectionBubbles";
import React, {useEffect, useState} from "react";
import {Trophy, ChevronLeft, ChevronRight, BadgeInfo} from 'lucide-react';
import RewardDetailModal from "./RewardDetailModal";
import {useGetAwardsGamification} from "../../api/award";
import {CommonIcon} from "../../../../core/components/icon";
import RenderIf from "../../../../core/components/render-if";
import {Empty, Select} from "antd";
import {Link} from "react-router-dom";
import ScrollView from "../../../../core/components/scroll-view";
import RewardLoader from "./LoadingGame";
import {useAuthContext} from "../../../Auth/provider/AuthProvider";
import GamificationGuideModal from "../gamification_guide";

export const theme = {
    primary: '#820f99',
    deep: '#301466',
    light: '#c084fc',
    accent: '#d946ef',
    yellow: '#EFCD46FF'
};


export default function RewardSystem() {
    const [open, setOpen] = useState(false)
    const [selectedReward, setSelectedReward] = useState(null);
    const [scrollOffset, setScrollOffset] = useState(0);
    const [awardType, setAwardType] = useState("user");
    const [selectedTeamId, setSelectedTeamId] = useState();
    const {allTeams} = useAuthContext()
    useEffect(() => {
        if (!selectedTeamId && allTeams.length) {
            setSelectedTeamId(allTeams[0]?.team?.id);
        }
    }, [allTeams]);

    const {
        data: awardsData,
        isPending,
        isSuccess,
        refetch: refetchAwards
    } = useGetAwardsGamification(
        {team_id: selectedTeamId}
    );

    const awards = awardsData?.data || [];

    const groupedAwards = Object.entries(
        awards.reduce((acc, award) => {
            const type = award.type || "other"; // user | team

            if (!acc[type]) {
                acc[type] = {};
            }

            const topicId = award.topic?.id ?? "no-topic";
            const prefixId = award.prefix?.id ?? "no-prefix";

            // create topic
            if (!acc[type][topicId]) {
                acc[type][topicId] = {
                    topic: {
                        ...award.topic,
                        currentScore: 0,
                        currentExperience: 0,
                    },
                    prefixes: {},
                };
            }

            // topic values
            acc[type][topicId].topic.currentScore = Math.max(
                acc[type][topicId].topic.currentScore,
                award.currentScore ?? 0
            );

            acc[type][topicId].topic.currentExperience = Math.max(
                acc[type][topicId].topic.currentExperience,
                award.currentExperience ?? 0
            );

            // create prefix
            if (!acc[type][topicId].prefixes[prefixId]) {
                acc[type][topicId].prefixes[prefixId] = {
                    prefix: award.prefix,
                    awards: [],
                };
            }

            acc[type][topicId].prefixes[prefixId].awards.push(award);

            return acc;
        }, {})
    ).reduce((result, [type, topics]) => {
        result[type] = Object.values(topics).map((topicItem) => ({
            ...topicItem,
            prefixes: Object.values(topicItem.prefixes),
        }));

        return result;
    }, {});



    const teamAwards = groupedAwards?.team || [];

    const teams = [
        ...new Map(
            awards
                .filter(item => item.type === "team" && item.team)
                .map(item => [item.team.id, item.team])
        ).values()
    ];

    const selectedTeam =
        allTeams?.at(0)?.team
        // teams.find(t => t.id === selectedTeamId) || teams[0];

    const visibleTeamAwards = teamAwards.filter(topic =>
        topic?.prefixes?.some(prefix =>
            prefix?.awards?.some(
                award => award?.team?.id === selectedTeam?.id
            )
        )
    );

    const visibleAwards =
        awardType === "user"
            ? groupedAwards?.user || []
            : groupedAwards?.team || [];
    const handleRewardClick = (reward) => {
        const status = reward?.beforeTakenStatus === "taken" ? 'earned'
            : reward?.beforeTakenStatus === "pending_take" ? 'pending_take'
                : reward?.canGet === true ? 'available'
                    : 'locked';
        setSelectedReward({...reward, _status: status});
    };

    return (
        <div
            className="min-h-screen w-full pt-8 pb-24"
            style={{
                background: `linear-gradient(160deg, #0a0612 0%, ${theme.deep} 40%, #0a0612 100%)`,
                direction: 'rtl',
            }}
        >
            <GamificationGuideModal open={open} onClose={() => setOpen(false)}/>
            <RenderIf cond={isPending}>
                <RewardLoader/>
            </RenderIf>
            <RenderIf cond={isSuccess}>


                <div className="absolute inset-0 pointer-events-none ">
                    {[...Array(110)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute rounded-full"
                            style={{
                                width: Math.random() * 4 + 1,
                                height: Math.random() * 4 + 1,
                                left: `${Math.random() * 100}%`,
                                top: `${Math.random() * 100}%`,
                                background: theme.light,
                                opacity: Math.random() * 0.3 + 0.1,
                                animation: `float ${3 + Math.random() * 4}s ease-in-out infinite`,
                                animationDelay: `${Math.random() * 3}s`,
                            }}
                        />
                    ))}
                </div>

                <div className="relative max-w-6xl mx-auto px-4 py-6">
                    <div className="flex items-center justify-between mb-6">
                        <div>
                            <h1
                                className="text-2xl md:text-3xl font-black text-white mb-1"
                                style={{textShadow: `0 0 20px ${theme.accent}44`}}
                            >
                                مسیر رشد
                            </h1>
                            <p className="text-sm" style={{color: theme.light}}>
                                جایزه‌ها رو یکی یکی بگیر و افسانه شو!
                            </p>
                        </div>
                        <div className={'flex gap-2 justify-center items-center'}>
                            <Link to={'/app/my-award'}>
                                <div
                                        className="flex items-center gap-2 px-4 py-2 rounded-2xl"
                                        style={{
                                            background: `${theme.primary}33`,
                                            border: `1px solid ${theme.light}33`,
                                        }}
                                    >
                                        <Trophy size={20} style={{color: theme.accent}} fill={theme.accent}/>
                                        <span className="font-bold" style={{color: theme.light}}>
                                         لیست جوایز من
                                    </span>
                                </div>
                            </Link>
                            <span onClick={()=> setOpen(true)} className="font-bold" style={{color: theme.light}}>
                                <BadgeInfo size={36} />
                            </span>
                        </div>
                    </div>

                    {/*<div className="mb-6">*/}
                    {/*    <div className="flex items-center justify-between mb-2">*/}
                    {/*        <span className="text-xs font-bold" style={{color: theme.light}}>*/}
                    {/*          پیشرفت کلی*/}
                    {/*        </span>*/}
                    {/*        <span className="text-xs font-bold" style={{color: theme.accent}}>*/}
                    {/*          {progressPct}%*/}
                    {/*        </span>*/}
                    {/*    </div>*/}
                    {/*    <div*/}
                    {/*        className="h-3 rounded-full overflow-hidden"*/}
                    {/*        style={{background: `${theme.deep}66`}}*/}
                    {/*    >*/}
                    {/*        <div*/}
                    {/*            className="h-full rounded-full transition-all duration-1000"*/}
                    {/*            style={{*/}
                    {/*                width: `${progressPct}%`,*/}
                    {/*                background: `linear-gradient(90deg, ${theme.primary}, ${theme.accent})`,*/}
                    {/*                boxShadow: `0 0 10px ${theme.accent}66`,*/}
                    {/*            }}*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*    <div className="flex items-center justify-between mt-1.5">*/}
                    {/*        <span className="text-xs" style={{color: '#888'}}>*/}
                    {/*          {totalEarned} از {totalRewards} جایزه*/}
                    {/*        </span>*/}
                    {/*        <span className="text-xs" style={{color: '#888'}}>*/}
                    {/*          {completedSections} از {sections.length} بخش کامل*/}
                    {/*        </span>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className="relative">
                        <button
                            onClick={() => setScrollOffset((p) => Math.min(p + 300, 0))}
                            className="absolute right-0 top-1/2 -translate-y-1/2 rounded-full p-2 hidden md:flex items-center justify-center"
                            style={{
                                background: `${theme.primary}99`,
                                border: `1px solid ${theme.light}44`,
                                boxShadow: `0 0 15px ${theme.primary}44`,
                            }}
                        >
                            <ChevronRight size={20} color="white"/>
                        </button>
                        <button
                            onClick={() => setScrollOffset((p) => p - 300)}
                            className="absolute left-0 top-1/2 -translate-y-1/2 rounded-full p-2 hidden md:flex items-center justify-center"
                            style={{
                                background: `${theme.primary}99`,
                                border: `1px solid ${theme.light}44`,
                                boxShadow: `0 0 15px ${theme.primary}44`,
                            }}
                        >
                            <ChevronLeft size={20} color="white"/>
                        </button>
                        <div className="mb-6 flex flex-col gap-3">

                            <div
                                className="inline-flex p-1 rounded-2xl w-fit"
                                style={{
                                    background: `${theme.primary}22`,
                                    border: `1px solid ${theme.light}22`
                                }}
                            >
                                {[
                                    {
                                        key: "user",
                                        title: "فردی"
                                    },
                                    {
                                        key: "team",
                                        title: "تیمی"
                                    }
                                ].map(item => (
                                    <button
                                        key={item.key}
                                        onClick={() => setAwardType(item.key)}
                                        className="px-5 py-2 rounded-xl text-sm font-bold transition-all duration-300"
                                        style={{
                                            background:
                                                awardType === item.key
                                                    ? `linear-gradient(135deg, ${theme.primary}, ${theme.accent})`
                                                    : "transparent",

                                            color:
                                                awardType === item.key
                                                    ? "#fff"
                                                    : theme.light,

                                            boxShadow:
                                                awardType === item.key
                                                    ? `0 0 20px ${theme.accent}44`
                                                    : "none"
                                        }}
                                    >
                                        {item.title}
                                    </button>
                                ))}
                            </div>

                            {awardType === "team" && allTeams.length > 1 && (
                                <div className="max-w-sm">
                                    <Select
                                        size="large"
                                        value={selectedTeamId}
                                        onChange={setSelectedTeamId}
                                        className="w-full"
                                        popupMatchSelectWidth
                                        options={allTeams?.map(team => ({
                                            label: team?.team?.name,
                                            value: team?.team?.id
                                        }))}
                                    />
                                </div>
                            )}
                        </div>

                        <RenderIf cond={visibleAwards?.length === 0}>
                            <div className="text-white">

                                <Empty description={<>
                                    <div className="text-white">
                                        هیچ جایزه ای متناسب با امتیاز کسب شده شما یافت نشد
                                        <br/>
                                        <div className={'font-bold mt-2 text-xl'}>
                                            برای شروع باید ابتدا در ماموریت‌ها و دوره‌ها شرکت کنید و امتیاز کسب کنید
                                        </div>

                                    </div>
                                </>} className={'text-white'}/>
                            </div>
                        </RenderIf>
                        {visibleAwards?.map((topic, index) => {
                            return (
                                <div
                                    key={index + '-' + topic?.topic?.id + '-' + 'topic'}
                                    className="px-2 pt-2 pb-4 mb-2 scrollbar-hide border-[1px] border-[rgb(130,15,153)] rounded-lg"
                                    style={{scrollBehavior: 'smooth'}}>
                                    <div className="flex justify-between gap-3">
                                    <span
                                        className="text-sm font-bold"
                                        style={{color: "rgb(192, 132, 252)"}}
                                    >
                                  {topic?.topic?.title}

                                </span>
                                <div className={'flex gap-2'}>
                                    <RenderIf cond={awardType === 'user'}>
                                        <span
                                            className="text-sm flex font-bold"
                                            style={{color: "rgb(192, 132, 252)"}}
                                        >
                                        {topic?.topic?.currentExperience}
                                            <CommonIcon icon="xp"/>
                                    </span>
                                    </RenderIf>

                                    <RenderIf cond={awardType === 'team'}>
                                        <span
                                            className="text-sm flex font-bold"
                                            style={{color: "rgb(192, 132, 252)"}}
                                        >
                                        {topic?.topic?.currentScore}
                                            <CommonIcon icon="score"/>
                                    </span>
                                    </RenderIf>
                                </div>

                                    </div>
                                    <ScrollView className="relative z-[1] min-h-[14rem] gap-4 px-6">
                                        <div className="flex items-start pt-6 gap-3 md:gap-5"
                                             style={{
                                                 minWidth: 'max-content',
                                                 transform: `translateX(${scrollOffset}px)`
                                             }}>
                                            {topic?.prefixes?.map((section, i) => (
                                                <div key={section.id + '-' + i + '-' + 'sectionBubble'}
                                                     className="flex items-center">
                                                    <SectionBubbles
                                                        section={section}
                                                        sectionIndex={i}
                                                        onRewardClick={handleRewardClick}
                                                    />
                                                    {i < topic?.prefixes?.length - 1 && (
                                                        <div
                                                            className="flex items-center mx-2 md:mx-4 self-center"
                                                            style={{marginTop: 30}}
                                                        >
                                                            <svg
                                                                width="40"
                                                                height="16"
                                                                viewBox="0 0 40 16"
                                                                className="hidden md:block"
                                                            >
                                                                <defs>
                                                                    <linearGradient id={`pathGrad${i}`} x1="1" y1="0"
                                                                                    x2="0"
                                                                                    y2="0">
                                                                        <stop
                                                                            offset="0%"
                                                                            stopColor={

                                                                                theme.accent

                                                                            }
                                                                        />
                                                                        <stop
                                                                            offset="100%"
                                                                            stopColor={

                                                                                theme.accent

                                                                            }
                                                                        />
                                                                    </linearGradient>
                                                                </defs>

                                                                <line
                                                                    x1="40"
                                                                    y1="8"
                                                                    x2="8"
                                                                    y2="8"
                                                                    stroke={`url(#pathGrad${i})`}
                                                                    strokeWidth="3"
                                                                    strokeDasharray={

                                                                        '6 4'
                                                                    }
                                                                />


                                                                <circle r="3" cy="8" fill={theme.accent}>
                                                                    <animate
                                                                        attributeName="cx"
                                                                        from="40"
                                                                        to="8"
                                                                        dur="2s"
                                                                        repeatCount="indefinite"
                                                                    />
                                                                    <animate
                                                                        attributeName="opacity"
                                                                        values="1;0.3;1"
                                                                        dur="2s"
                                                                        repeatCount="indefinite"
                                                                    />
                                                                </circle>

                                                                {/* فلش سمت چپ */}
                                                                <polygon
                                                                    points="0,8 8,4 8,12"
                                                                    fill={theme.accent}
                                                                />
                                                            </svg>

                                                            <svg
                                                                width="20"
                                                                height="16"
                                                                viewBox="0 0 20 16"
                                                                className="md:hidden"
                                                            >
                                                                <line
                                                                    x1="18"
                                                                    y1="8"
                                                                    x2="8"
                                                                    y2="8"
                                                                    stroke={theme.accent}
                                                                    strokeWidth="2"
                                                                    strokeDasharray={'4 3'}
                                                                />

                                                                <circle r="2.5" cy="8" fill={theme.accent}>
                                                                    <animate
                                                                        attributeName="cx"
                                                                        from="18"
                                                                        to="8"
                                                                        dur="2s"
                                                                        repeatCount="indefinite"
                                                                    />
                                                                    <animate
                                                                        attributeName="opacity"
                                                                        values="1;0.3;1"
                                                                        dur="2s"
                                                                        repeatCount="indefinite"
                                                                    />
                                                                </circle>


                                                                {/* فلش سمت چپ */}
                                                                <polygon
                                                                    points="0,8 8,4 8,12"
                                                                    fill={theme.accent}
                                                                />
                                                            </svg>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </ScrollView>
                                </div>
                            )
                        })}
                    </div>
                    <RenderIf cond={groupedAwards?.length > 0}>
                        <div className="mt-6 flex flex-wrap items-center justify-center gap-4 text-xs">
                            <div className="flex items-center gap-1.5">
                                <div className="w-3 h-3 rounded-full"
                                     style={{background: `linear-gradient(135deg, #22c55e, #16a34a)`}}/>
                                <span style={{color: '#aaa'}}>دریافت شده</span>
                            </div>
                            <div className="flex items-center gap-1.5">
                                <div className="w-3 h-3 rounded-full" style={{
                                    background: `linear-gradient(135deg, ${theme.accent}, ${theme.primary})`,
                                    boxShadow: `0 0 6px ${theme.accent}44`
                                }}/>
                                <span style={{color: '#aaa'}}>قابل دریافت</span>
                            </div>
                            <div className="flex items-center gap-1.5">
                                <div className="w-3 h-3 rounded-full" style={{
                                    background: `linear-gradient(135deg, ${theme.yellow}, ${theme.primary})`,
                                    boxShadow: `0 0 6px ${theme.yellow}44`
                                }}/>
                                <span style={{color: '#aaa'}}>در انتظار تایید</span>
                            </div>
                            <div className="flex items-center gap-1.5">
                                <div className="w-3 h-3 rounded-full" style={{background: '#333'}}/>
                                <span style={{color: '#aaa'}}>قفل شده</span>
                            </div>

                        </div>
                    </RenderIf>
                </div>
            </RenderIf>
            <div className="flex justify-center">
                <Link to="/app/awards/race">
                    <button
                        className="group flex items-center gap-3 px-8 py-4 rounded-2xl transition-all duration-300 hover:scale-105"
                        style={{
                            background: `linear-gradient(135deg, ${theme.primary}, ${theme.accent})`,
                            boxShadow: `0 0 25px ${theme.accent}55`,
                            border: `1px solid ${theme.light}44`,
                        }}
                    >
                        <Trophy
                            color={theme.yellow}
                            fill={theme.yellow}
                            size={26}
                        />
                        <span className="text-white font-bold text-base">
                            برترین‌ها
                        </span>
                    </button>
                </Link>
            </div>

            {selectedReward && (
                <RewardDetailModal
                    reward={selectedReward}
                    status={selectedReward._status}
                    onClose={() => setSelectedReward(null)}
                    refetchAwards={refetchAwards}
                    selectedTeamId={selectedTeamId}
                />
            )}
        </div>
    );
}

